// context <API></>
// useContext hooks

// context(warehouse)
// Provider (delivery boy)
// consumer / (useContext() (i.e., myself))
import React, { useContext, useEffect, useState } from 'react';

export const API_URl = `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`;

const AppContext = React.createContext();

//we need to create a provider function

const AppProvider = ({children}) =>{

    const [isLoading, setIsLoading] = useState(true);
    const [movie,setMovie] = useState([]);
    const [isError, setIsError] = useState({show: "false", msg: ""});
    const [query,setQuery] = useState("titanic");

    const getMovies = async(url)=>{
        try{
            const res = await fetch(url);
            const data = await res.json();
            console.log(data);
            if(data.Response === "True")
            {
                setIsLoading(false);
                setIsError({
                    show: false,
                    msg: ""
                });
                setMovie(data.Search);
            }
            else
            {
                setIsError({
                    show: true,
                    msg: data.Error
                });
            }
        } catch(error){
            console.log(error);
        }
    };

    useEffect(() => {
        let timerOut = setTimeout(()=>{
            getMovies(`${API_URl}&s=${query}`);
        },800);

        return ()=> clearTimeout(timerOut);
    }, [query]);
    

    return <AppContext.Provider value={{isLoading, isError, movie,query, setQuery }}>
        {children}
    </AppContext.Provider>
};

//Global custom hooks
const useGlobalContext = () =>{
    return useContext(AppContext);
};

export {AppContext, AppProvider, useGlobalContext };

//https://www.omdbapi.com/?apikey=200f8567&s=titanic